import { axiosInstance } from "../client";
import { CollectionResponse } from "@rumble-it/common-lib/types/api/CollectionResponse.interface";
import { Rule } from "@rumble-it/common-lib/types/models/Rule.interface";
import { MIME_TYPE_MERGE_PATCH_JSON } from "@rumble-it/common-lib/src/constants/mimeTypes";
import { PaginationParams } from "@rumble-it/common-lib/types/api/PaginationParams.interface";

export interface DefaultQueryParams extends PaginationParams {}

// Rules
export const fetchRules = async (
  params: DefaultQueryParams,
): Promise<CollectionResponse<Rule>> =>
  axiosInstance.get("/rules", { params }).then((response) => response.data);

export const fetchRuleById = async (id: string): Promise<Rule> =>
  axiosInstance.get(`/rules/${id}`).then((r) => r.data);

export const createRule = async (data: Partial<Rule>): Promise<Rule> =>
  axiosInstance.post(`/rules`, data).then((r) => r.data);

export const updateRuleById = async (
  id: string,
  data: Partial<Rule>,
): Promise<Rule> =>
  axiosInstance
    .patch(`/rules/${id}`, data, {
      headers: { "Content-Type": MIME_TYPE_MERGE_PATCH_JSON },
    })
    .then((r) => r.data);

export const deleteRuleById = async (id: string): Promise<null> =>
  axiosInstance.delete(`/rules/${id}`).then((r) => r.data);
